/**
 * API Configuration Helper
 * Provides the backend URL from runtime config or environment variables
 */

// Get backend URL - check environment variable first (baked at build time by CRA)
const getUrlFromEnv = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl.length > 0 && !envUrl.includes('PLACEHOLDER') && !envUrl.includes('undefined')) {
    return envUrl;
  }
  return null;
};

// Get backend URL from runtime config (Docker/Railway)
const getUrlFromRuntime = () => {
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__?.BACKEND_URL) {
    const url = window.__RUNTIME_CONFIG__.BACKEND_URL;
    if (url && !url.includes('PLACEHOLDER') && !url.includes('undefined') && !url.includes('localhost')) {
      return url;
    }
  }
  return null;
};

// Main function to get backend URL
export const getBackendUrl = () => {
  // Priority 1: Runtime config (Docker/Railway production - injected at container start)
  const runtimeUrl = getUrlFromRuntime();
  if (runtimeUrl) {
    return runtimeUrl;
  }
  
  // Priority 2: Environment variable (CRA bakes this at build time)
  const envUrl = getUrlFromEnv();
  if (envUrl) {
    return envUrl;
  }
  
  // Priority 3: Default for local development
  return 'http://localhost:8001';
};

// Export the URL - computed once at module load
export const API_BASE_URL = getBackendUrl();
